import { api } from "../Api.ts";
import i18n from "../../Config/i18n.js";
import { AxiosError } from 'axios';

/**
 * Classe que faz as requisições dos usuários
 */
export class UserRequests {
    /**
     * Faz a requisição de confirmação de email
     */
    async ConfirmEmail():Promise<any>{
        try {
            const response = await api.get('/confirm-email');
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } 
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz a requisição para confirmar o email
     * @param {string} Token de email
     */
    async SendToken(Token : string):Promise<any>{
        try {
            const response = await api.get(`/confirm-email/${Token}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } 
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz a requisição para pegar o qrcode de autenticação
     */
    async Getqrcode():Promise<any>{
        try {
            const response = await api.get(`/generate-2fa-qr-code`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } 
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Enviar Token para autenticação de dois fatores
     * @param {string} code codigo de autenticação
     */
    async sendAuthCode (code : string,):Promise<any>{
        try {
            const response = await api.post('/VerifyCode', {'codigo': code});
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw new Error(error.response?.data?.message? error.response.data.message :i18n.t('request-errors.unauthenticated'));
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } 
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Reseta o botão de autenticação de dois fatores
     * @param {string} id do usuário
     */
    async Reset2FactorAuth (id : string,):Promise<any>{
        try {
            const response = await api.post('/reset2FA', {'user': id});
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw new Error(error.response?.data?.message? error.response.data.message :i18n.t('request-errors.unauthenticated'));
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } 
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Enviar Código de recuperação de autenticação de dois fatores
     * @param {string} code codigo de recuperação
     */
    async sendRecoveryCode (code : string,):Promise<any>{
        try {
            const response = await api.post('/verifyBackupCode2Fa', {'codigo': code});
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw new Error(error.response?.data?.message? error.response.data.message :i18n.t('request-errors.unauthenticated'));
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } 
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz a requisição para pegar o usuário
     * @param {string} id do usuário
     */
    async GetUser(id: string):Promise<any>{
        try {
            const response = await api.get(`/Users/${id}`);
            return response;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz requisição para pegar a alocações que o usuário pode ver
     */
    async getlocations():Promise<any>{
        try {
            const response = await api.get(`/userAllocables`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz a requisição para editar o usuário
     * @param id id do usuário a ser editado
     * @param Body informações a serem editadas
     * method-spoofing
     */
    async editUser(id : string, Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/Users/${id}`, Body, {
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error) {
            if (error instanceof AxiosError) {
                if(error.response?.status === 401){
                    throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
                } else if (error.response && error.response.data && error.response.data.message) {
                    const errorMessage = error.response.data.message;
                    throw new Error(errorMessage);
                } 
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz a requisição para editar o usuário
     * @param id id do usuário a ser editado
     * @param Body foto a ser editada
     * method-spoofing
     */
    async editUserImage(id : string, Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/Users/setImage/${id}`, Body, {
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz a requisição para editar o usuário
     * @param id id do usuário no qual a foto será removida
     * method-spoofing
     */
    async deleteUserImage(id : string):Promise<any>{
        try {
            const response = await api.delete(`/Users/removeImage/${id}`);
            return response.data;
        } catch (error: any) {
            if (error instanceof AxiosError) {
                if(error.response?.status === 401){
                    throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
                } else if (error.response && error.response.data && error.response.data.message) {
                    const errorMessage = error.response.data.message;
                    throw new Error(errorMessage);
                }
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz a requisição para esconder a foto do usuário
     * @param id id do usuário para esconder a foto
     * @param hidden_file_image verdadeiro ou falso para esconder ou mostrar a imagem
     * method-spoofing
     */
    async hideUserImage(id : string, hidden_file_image: boolean):Promise<any>{
        try {
            const response = await api.post(`/Users/${id}`, { "showImage" : hidden_file_image ? 1 : 0}, {
                headers: {'Accept': 'multipart/form-data'},
            });
            return response.data;
        } catch (error: any) {
            if (error instanceof AxiosError) {
                if(error.response?.status === 401){
                    throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
                } else if (error.response && error.response.data && error.response.data.message) {
                    const errorMessage = error.response.data.message;
                    throw new Error(errorMessage);
                }
            }

            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz a requisição para editar as unidades de medida do usuário
     * @param id id do usuário para editar as unidades
     * @param Body informações a serem editadas
     */
    async editMeasurementUnits(id : string, Body: FormData):Promise<any>{
        try {
            const response = await api.patch(`/Users/${id}`, Body,{
                headers: {'Accept': 'application/json', "Content-Type": "application/json"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para editar a senha do usuário
     * @param Body informações a serem editadas
     */
    async ChangePassword(Body: object):Promise<any>{
        try {
            const response = await api.put(`/changePassword`, Body,);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }


    async getAllUser(page: number, search: string, roles: Array<string>, allocations: Array<string>):Promise<any>{
        try {
            let url = `/Users?`;
            if(search) {
                url += `search=${search}&`;
            }
            if(roles && roles.length > 0){
                roles.map(role=>{
                    url += `roles[]=${role}&`;
                    return role
                })
            }
            if(allocations && allocations.length > 0){
                allocations.map(allocation=>{
                    url += `allocations[]=${allocation}&`;
                    return allocation
                })
            }
            if(page){
                url += `page=${page}`;
            }
            const response = await api.get(url);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz a requisição para editar o usuário
     * @param Body informações a serem editadas
     * method-spoofing
     */
    async CreateUser(Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/Users/`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz a requisição para editar o usuário
     * @param Body informações a serem editadas
     * method-spoofing
     */
    async CreateUserPass(Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/v2/Users/`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz requisição para pegar a alocações que o usuário pode ver
     */
    async getAuthorizedAllocations():Promise<any>{
        try {
            const response = await api.get(`/me/authorizedAllocations`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Faz requisição para pegar os cargos que o usuário pode ver
     */
    async getAuthorizedCargos():Promise<any>{
        try {
            const response = await api.get(`/me/authorizedCargos`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }   

    /**
     * Faz a requisição para excluir o usuário
     * @param id id do usuário a ser editado
     * method-spoofing
     */
    async deleteUser(id: string):Promise<any>{
        try {
            const response = await api.delete(`/Users/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Envia código de verificação para o wpp
     */
    async sendWhatsappCode():Promise<any>{
        try {
            const response = await api.post(`/sendConfirmationWhats`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Envia código de verificação para o tefelone
     */
    async sendPhoneCode():Promise<any>{
        try {
            const response = await api.post(`/sendConfirmationPhoneNumber`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } 
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Envia código de verificação para o wpp
     */
    async sendWhatsappCodeConfirm(code: string):Promise<any>{
        try {
            const response = await api.post(`/verifyCodeWhatsapp `,{
                'code': code
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Envia código de verificação para o telefone
     */
    async sendPhoneCodeConfirm(code: string):Promise<any>{
        try {
            const response = await api.post(`/verifyPhoneNumber`,{
                'code': code
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }


    /**
     * Busca as inscrições do usuário ja listando os equipamentos
     */
    async getUserSubscribes(): Promise<any>{
        try {
            const Equipamentos = await api.get(`/me/getEligibleEquipmentsForSubscription`);
            return Equipamentos.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } 
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * Busca as variáveis de alertas do equipamento
     * @param id id do equipamento
     */
    async GetVariables(id: string): Promise <any>{
        try {
            const Equipamentos = await api.get(`/getPossibleAlertsForEquipment/${id}`);
            return Equipamentos.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } 
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }


    /**
     * Busca as variáveis de alertas do equipamento
     * @param id id do equipamento
     */
    async GetPermissions(id: string): Promise <any>{
        try {
            const Permissions = await api.get(`/Users/sendCommandsEquipments/${id}`);
            return Permissions.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } 
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }


    /**
     * inscreve o usuário em um equipamento com configurações de alerta
     * @param Body informações a serem editadas
     */
    async subscribe (Body: FormData): Promise <any>{
        try {
            const response = await api.post(`/subscribeEquipmentAlert`, Body);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            }
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
     * cancela a inscrição do usuário em um equipamento
     * @param id id do equipamento
     */
    async unsubscribe(id: string): Promise <any>{
        try {
            const response = await api.delete(`/unsubscribeEquipmentAlert/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } 
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }


    /**
     * cancela permissões do usuário em um equipamento
     * @param userId id do usuário
     * @param equipamento id do equipamento
     */
    async unpermission(userId: string, equipamento: string): Promise <any>{
        try {
            const response = await api.delete(`/removePermissionToSendCommands/${userId}/${equipamento}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * adiciona permissões do usuário em um equipamento
     * @param id id do equipamento
     */
    async permission(id: string, equipamento: string):Promise<any>{
        try {
            const response = await api.post(`/givePermissionToSendCommands`, {
                'user_id': id,
                'poco_id': equipamento
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * busca as cidade do usuário
     */
    async RequestCities():Promise<any>{
        try {
            const response = await api.get('/me/authorizedCities');
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } 
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }

    /**
    * encerra sessão de um dispositivo em específico
    */
    async RequestDeviceLogout(id: number):Promise<any>{
        try {
            const response = await api.delete(`/Users/token/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } 
            throw new Error(i18n.t('request-errors.server-connection'));
        }
    }
}